import { render, staticRenderFns } from "./thesaurus_management.vue?vue&type=template&id=3d61fd8f&scoped=true&"
import script from "./thesaurus_management.vue?vue&type=script&lang=js&"
export * from "./thesaurus_management.vue?vue&type=script&lang=js&"
import style0 from "./thesaurus_management.vue?vue&type=style&index=0&id=3d61fd8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61fd8f",
  null
  
)

export default component.exports